export const purchaseBuyers = [
  { name: "Florencia R.", place: "La Plata, Buenos Aires" },
  { name: "Gabriela M.", place: "Rosario, Santa Fe" },
  { name: "Silvina P.", place: "Córdoba Capital" },
  { name: "Natalia G.", place: "Mendoza" },
  { name: "Romina L.", place: "San Miguel de Tucumán" },
  { name: "Verónica S.", place: "Mar del Plata, Buenos Aires" },
  { name: "Paula D.", place: "Salta" },
  { name: "Lorena F.", place: "Neuquén" },
  { name: "Andrea C.", place: "Santa Fe Capital" },
  { name: "Mariana B.", place: "Corrientes" },
  { name: "Daniela V.", place: "Posadas, Misiones" },
  { name: "Cecilia T.", place: "Bahía Blanca, Buenos Aires" },
  { name: "Julieta A.", place: "San Juan" },
  { name: "Soledad H.", place: "Paraná, Entre Ríos" },
  { name: "Martín O.", place: "Quilmes, Buenos Aires" },
  { name: "Valeria N.", place: "Resistencia, Chaco" },
  { name: "Carla E.", place: "San Luis" },
  { name: "Luciana Q.", place: "Comodoro Rivadavia, Chubut" },
  { name: "Eugenia K.", place: "Santiago del Estero" },
  { name: "Pablo I.", place: "Morón, Buenos Aires" },
];

export const purchaseToast = {
  label: "Compra verificada",
  bought: "compró",
  firstDelayMs: 12000,
  minIntervalMs: 40000,
  maxIntervalMs: 60000,
  visibleMs: 6000,
};
